<script setup lang="ts">
import { mdiShapeOutline } from '@quasar/extras/mdi-v7';

defineProps<{
  categoryBreakdown: {
    category: string;
    count: number;
    averageScore: number | null;
  }[];
}>();
</script>
<template>
  <div class="stat-card acc-neutral">
    <div class="stat-card__head">
      <div class="stat-card__title">{{ $t('CATEGORY_BREAKDOWN') }}</div>
      <div class="stat-badge stat-badge--sm">
        <q-icon
          :name="mdiShapeOutline"
          size="18px"
        />
      </div>
    </div>

    <div
      v-if="categoryBreakdown.length"
      class="stat-rows"
    >
      <div
        v-for="cat in categoryBreakdown"
        :key="cat.category"
        class="cat-row"
      >
        <div class="row items-center justify-between q-mb-xs">
          <div class="stat-label">{{ cat.category }}</div>
          <div class="row items-center q-gutter-x-sm no-wrap">
            <span class="stat-sub">×{{ cat.count }}</span>
            <span class="cat-score">{{
              cat.averageScore !== null ? Math.round(cat.averageScore) + '%' : '–'
            }}</span>
          </div>
        </div>
        <q-linear-progress
          rounded
          size="6px"
          :value="(cat.averageScore || 0) / 100"
          color="primary"
          track-color="grey-3"
        />
      </div>
    </div>

    <div
      v-else
      class="stat-empty"
    >
      {{ $t('NO_DATA_AVAILIABLE') }}
    </div>
  </div>
</template>
<style scoped>
.cat-score {
  font-size: 13px;
  font-weight: 700;
  color: #1c1c1c;
}
.body--dark .cat-score {
  color: #f2f2f2;
}
</style>
